export interface StripeProduct {
  id: string;
  priceId: string;
  name: string;
  description: string;
  mode: 'payment' | 'subscription';
  price: number;
  currency: string;
}

export const STRIPE_PRODUCTS: StripeProduct[] = [
  {
    id: 'prod_SE1kdQuTXAGL7r',
    priceId: 'price_1RJZggL6ZBY2TAP3azvmUC4I',
    name: 'Meet&Eat Premium Lifetime',
    description: 'Ihnen gefällt unsere Seite so gut, dass sie sowieso nie wieder darauf verzichten wollen? Dann sichern sie sich jetzt Premium auf Lebenszeit',
    mode: 'payment',
    price: 9999,
    currency: 'EUR'
  },
  {
    id: 'prod_SE1hVBwKMywhww',
    priceId: 'price_1RJZdgL6ZBY2TAP37kVtdPgk',
    name: 'Meet&Eat Premium 1 Monat',
    description: 'Genießen sie alle Vorteile von Meet&Eat indem sie Premium Kunde werden.',
    mode: 'subscription',
    price: 799,
    currency: 'EUR'
  }
];